<template>
  <div class="page-tabs">
    <nav-tabs-card>
      <template slot="content">
        <span class="md-nav-tabs-title" v-if="title">{{ title }}</span>
        <md-tabs class="md-info md-white" md-alignment="left">
          <slot></slot>
        </md-tabs>
      </template>
    </nav-tabs-card>
  </div>
</template>

<script>
import { NavTabsCard } from '@/components';

export default {
  name: 'PageTabs',
  components: { NavTabsCard },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.page-tabs {
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  width: 100%;
  max-width: 100%;

  // Only target the internal content wrapper — do NOT touch navigation
  ::v-deep .md-tabs-content {
    width: 100%;
    max-width: 100%;
    overflow: hidden;

    // Each tab pane should fill the width
    .md-tab-pane {
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
  }

  // Ensure the nav-tabs-card doesn't add extra padding that breaks layout
  ::v-deep .md-card-content {
    padding: 0 !important;
  }

  // Navigation container — allow it to size itself naturally
  ::v-deep .md-tabs-navigation {
    padding: 0 20px;
    border-bottom: 1px solid #e8e8e8;
    background: #fafbfc;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
}
</style>